import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-row", {
    staticClass: "text-center pz-font-size-bs"
  }, [_c("el-col", {
    attrs: {
      xl: {
        span: 12,
        offset: 6
      },
      lg: {
        span: 12,
        offset: 6
      },
      md: {
        span: 12,
        offset: 6
      },
      sm: {
        span: 12,
        offset: 6
      },
      xs: {
        span: 24
      }
    }
  }, [_c("el-col", {
    class: ["pz-clearfix", "border-bottom"],
    attrs: {
      span: 24
    }
  }, [_c("el-col", {
    staticClass: "text-left",
    attrs: {
      span: 12
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("forms_flujo.oferta_solicitud_table.amount_requested")) + " ")]), _c("el-col", {
    staticClass: "text-right",
    attrs: {
      span: 12
    }
  }, [_c("transition", {
    attrs: {
      name: "breadcrumb"
    }
  }, [_c("b", {
    key: _vm.myForm.form.monto_oferta
  }, [_vm._v(" " + _vm._s(_vm._f("currency")(_vm.myForm.form.monto_oferta, _vm.myForm.producto.moneda_prestamo.symbol, _vm.myForm.form.cant_decimales)))])])], 1)], 1), _c("el-col", {
    class: ["pz-clearfix", "border-bottom"],
    attrs: {
      span: 24
    }
  }, [_c("el-col", {
    staticClass: "text-left",
    attrs: {
      span: 12
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("forms_flujo.oferta_solicitud_table.plazo")) + " ")]), _c("el-col", {
    staticClass: "text-right",
    attrs: {
      span: 12
    }
  }, [_c("transition", {
    attrs: {
      name: "breadcrumb"
    }
  }, [_c("b", {
    key: _vm.myForm.form.plazo
  }, [_vm._v(" " + _vm._s(_vm.$tc("forms_flujo.oferta_solicitud_table.plazo_cuotas", _vm.myForm.form.plazo, {
    cuotas: _vm.myForm.form.plazo,
    type: _vm.myForm.producto.term_type.name
  })) + " ")])])], 1)], 1), !_vm.ocultarResultado ? _c("el-col", {
    class: ["pz-clearfix", "border-bottom"],
    attrs: {
      span: 24
    }
  }, [_c("el-col", {
    staticClass: "text-left",
    attrs: {
      span: 12
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("forms_flujo.oferta_solicitud_table.amount_cba")) + " ")]), _c("el-col", {
    staticClass: "text-right",
    attrs: {
      span: 12
    }
  }, [_c("transition", {
    attrs: {
      name: "breadcrumb"
    }
  }, [_vm.myForm.form.cuota_sugerida !== 0 ? _c("b", {
    key: _vm.myForm.form.cuota_sugerida
  }, [_vm._v(" " + _vm._s(_vm._f("currency")(_vm.myForm.form.cuota_sugerida, _vm.myForm.producto.moneda_prestamo.symbol, _vm.myForm.form.cant_decimales)) + " ")]) : _c("b", {
    key: _vm.myForm.form.cuota_sugerida,
    staticClass: "font-weight-bold"
  }, [_vm._v(" ... ")])])], 1)], 1) : _vm._e(), !_vm.ocultarResultado ? _c("el-col", {
    class: ["pz-clearfix", "border-bottom"],
    attrs: {
      span: 24
    }
  }, [_c("el-col", {
    staticClass: "text-left",
    attrs: {
      span: 12
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("forms_flujo.oferta_solicitud_table.fecha_pago")) + " ")]), _c("el-col", {
    staticClass: "text-right",
    attrs: {
      span: 12
    }
  }, [_c("transition", {
    attrs: {
      name: "breadcrumb"
    }
  }, [_c("b", [_vm._v(" " + _vm._s(_vm.myForm.form.fecha_primer_vencimiento) + " ")])])], 1)], 1) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };